// extracted by mini-css-extract-plugin
export default {"container":"NF-z","heading":"OF-z","text":"PF-z","info":"QF-z","link":"RF-z","fullMaxWidth":"SF-z"};